import { render, staticRenderFns } from "./MinigamesContainer.vue?vue&type=template&id=ea123c36&scoped=true"
import script from "./MinigamesContainer.vue?vue&type=script&lang=js"
export * from "./MinigamesContainer.vue?vue&type=script&lang=js"
import style0 from "./MinigamesContainer.vue?vue&type=style&index=0&id=ea123c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea123c36",
  null
  
)

export default component.exports